<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      meta_data: {
        'solana-staking-rewards-01': {
          'url': 'https://www.posnode.com/solana-staking-rewards-01',
          'des': 'Staking your solana to PoS Node, and win a prize.',
          'image': 'https://www.posnode.com/static/images/social_solana_rewards.jpg',
          'title': 'Solana Staking Rewards'
        },
        'cardano-rewards-01': {
          'url': 'https://www.posnode.com/cardano-rewards-01',
          'des': 'Staking your cardano to PoS Node, and win a prize.',
          'image': 'https://www.posnode.com/static/images/social_rewards.jpg',
          'title': 'Cardano Staking Rewards'
        },
        'cardano-summer-staking-rewards': {
          'url': 'https://www.posnode.com/cardano-summer-staking-rewards',
          'des': 'Staking your cardano to PoS Node, and win a prize.',
          'image': 'https://www.posnode.com/static/images/cardano_summer_rewards.jpg',
          'title': 'Cardano Summer Staking Rewards'
        },
        'tron-staking': {
          'url': 'https://www.posnode.com/tron-staking',
          'des': 'PoS Node allows you to stake your Tron and receive rewards directly from the blockchain network. Learn how to stake Tron, the current staking interest, validator fees, rewards calculation and more.',
          'image': 'https://www.posnode.com/static/images/social/social_staking_tron.jpg',
          'title': 'Tron Staking'
        },
        'cardano-staking': {
          'url': 'https://www.posnode.com/cardano-staking',
          'des': 'You can earn Cardano staking rewards by simply delegating your ADA to PoS Node pool.The current estimated staking return is 3~5% APY.',
          'image': 'https://www.posnode.com/static/images/social_staking_ada.jpg',
          'title': 'Cardano Staking'
        },
        'irisnet-staking': {
          'url': 'https://www.posnode.com/irisnet-staking',
          'des': 'PoS Node allows you to stake your IRIS and recieve rewards directly from the IRISnet network. Learn how to stake IRIS, the current staking interest, validator fees, rewards calculations and more.',
          'image': 'https://www.posnode.com/static/images/social/social_staking_irisnet.jpg',
          'title': 'IRISnet Staking'
        },
        'certiK-staking': {
          'url': 'https://www.posnode.com/certiK-staking',
          'des': 'PoS Node allows you to stake your CTK token and recieve rewards directly from the CertiK network. Learn how to stake CTK, the current staking interest, validator fees, rewards calculations and more.',
          'image': 'https://www.posnode.com/static/images/social/social_staking_certik.jpg',
          'title': 'CertiK Staking'
        },
        'gravity-bridge-staking': {
          'url': 'https://www.posnode.com/gravity-bridge-staking',
          'des': 'PoS Node allows you to stake your GRAV and recieve rewards directly from the Gravity Bridge network. Learn how to stake GRAV, the current staking interest, validator fees, rewards calculations and more.',
          'image': 'https://www.posnode.com/static/images/social/social_staking_gravity.jpg',
          'title': 'Gravity Bridge Staking'
        },
        'oasis-network-staking': {
          'url': 'https://www.posnode.com/oasis-network-staking',
          'des': 'PoS Node allows you to stake your Rose and recieve rewards directly from the Oasis Network. Learn how to stake Rose, the current staking interest, validator fees, rewards calculations and more.',
          'image': 'https://www.posnode.com/static/images/social/social_staking_oasis.jpg',
          'title': 'Oasis Network Staking'
        },
        'tezos-staking': {
          'url': 'https://www.posnode.com/tezos-staking',
          'des': 'PoS Node allows you to stake your XTZ and recieve rewards directly from the Tezos blockchain network. Learn how to stake XTZ, the current staking interest, validator fees, rewards calculations and more.',
          'image': 'https://www.posnode.com/static/images/social/social_staking_tezos.jpg',
          'title': 'Tezos Staking'
        },
        'near-staking': {
          'url': 'https://www.posnode.com/near-staking',
          'des': 'PoS Node allows you to stake your NEAR and recieve rewards directly from the Near blockchain network. Learn how to stake NEAR, the current staking interest, validator fees, rewards calculations and more.',
          'image': 'https://www.posnode.com/static/images/social/social_staking_near.jpg',
          'title': 'Near Staking'
        },
        'terra-classic-staking': {
          'url': 'https://www.posnode.com/terra-classic-staking',
          'des': 'PoS Node allows you to stake your LUNC and recieve rewards directly from the Terra Classic blockchain network. Learn how to stake LUNC the current staking interest, faq,validator fees, rewards calculations and more.',
          'image': 'https://www.posnode.com/static/images/social/social_staking_terra.jpg',
          'title': 'Terra Classic Staking'
        },
        'solana-staking': {
          'url': 'https://www.posnode.com/solana-staking',
          'des': 'PoS Node allows you to stake your SOL and recieve rewards directly from the Solana blockchain network. Learn how to stake SOL, the current staking interest, validator fees, rewards calculations and more.',
          'image': 'https://www.posnode.com/static/images/social/social_staking_sol.jpg',
          'title': 'Solana Staking'
        },
        'Band-Protocol-staking': {
          'url': 'https://www.posnode.com/Band-Protocol-staking',
          'des': 'You can earn Cardano staking rewards by simply delegating your ADA to PoS Node pool.The current estimated staking return is 3~5% APY.',
          'image': 'https://www.posnode.com/static/images/social/social_staking_band.jpg',
          'title': 'Band Protocol Staking'
        },
        'kava-staking': {
          'url': 'https://www.posnode.com/kava-staking',
          'des': 'PoS Node allows you to stake your KAVA and recieve rewards directly from the Kava blockchain network. Learn how to stake KAVA, the current staking interest, faq, validator fees, rewards calculations and more.',
          'image': 'https://www.posnode.com/static/images/social/social_staking_kava.jpg',
          'title': 'Kava Staking'
        },
        'akash-network-staking': {
          'url': 'https://www.posnode.com/akash-network-staking',
          'des': 'PoS Node allows you to stake your AKT and recieve rewards directly from the Akash Network blockchain network. Learn how to stake AKT, the current staking interest, faq, validator fees, rewards calculations and more.',
          'image': 'https://www.posnode.com/static/images/social/social_staking_akash.jpg',
          'title': 'Akash Network Staking'
        },
        'umee-staking': {
          'url': 'https://www.posnode.com/umee-staking',
          'des': 'PoS Node allows you to stake your UMEE and recieve rewards directly from the Umee blockchain network. Learn how to stake UMEE the current staking interest, faq,validator fees, rewards calculations and more.',
          'image': 'https://www.posnode.com/static/images/social/social_staking_umee.jpg',
          'title': 'Umee Staking'
        },
        'sentinel-staking': {
          'url': 'https://www.posnode.com/sentinel-staking',
          'des': 'PoS Node allows you to stake your DVPN and recieve rewards directly from the Sentinel blockchain network. Learn how to stake DVPN, the current staking interest, validator fees, rewards calculations and more.',
          'image': 'https://www.posnode.com/static/images/social/social_staking_sentinel.jpg',
          'title': 'Sentinel Staking'
        },
        'sommelier-staking': {
          'url': 'https://www.posnode.com/sommelier-staking',
          'des': 'PoS Node allows you to stake your SOMM and recieve rewards directly from the Sommelier  blockchain network. Learn how to stake SOMM, the current staking interest, validator fees, rewards calculations and more.',
          'image': 'https://www.posnode.com/static/images/social/social_staking_sommelier.jpg',
          'title': 'Sommelier Staking'
        },
        'fetch-ai-staking': {
          'url': 'https://www.posnode.com/fetch-ai-staking',
          'des': 'PoS Node allows you to stake your FET and recieve rewards directly from the Fetch.ai blockchain network. Learn how to stake FET, the current staking interest, validator fees, rewards calculations and more.',
          'image': 'https://www.posnode.com/static/images/social/social_staking_fetchai.jpg',
          'title': 'Fetch.ai Staking'
        },
        'juno-staking': {
          'url': 'https://www.posnode.com/juno-staking',
          'des': 'PoS Node allows you to stake your JUNO and recieve rewards directly from the JUNO blockchain network. Learn how to stake JUNO, the current staking interest, validator fees, rewards calculations and more.',
          'image': 'https://www.posnode.com/static/images/social/social_staking_juno.jpg',
          'title': 'JUNO Staking'
        },
        'regen-network-staking': {
          'url': 'https://www.posnode.com/regen-network-staking',
          'des': 'PoS Node allows you to stake your REGEN and recieve rewards directly from the Regen blockchain network. Learn how to stake REGEN, the current staking interest, validator fees, rewards calculations and more.',
          'image': 'https://www.posnode.com/static/images/social/social_staking_regen.jpg',
          'title': 'Regen Network Staking'
        },
        'quicksilver-zone-staking': {
          'url': 'https://www.posnode.com/quicksilver-zone-staking',
          'des': 'PoS Node allows you to stake your QCK and recieve rewards directly from the Quicksilver blockchain network. Learn how to stake QCK, the current staking interest, validator fees, rewards calculations and more.',
          'image': 'https://www.posnode.com/static/images/social/social_staking_quicksilver.jpg',
          'title': 'Quicksilver Zone Staking'
        },
        'xpla-staking': {
          'url': 'https://www.posnode.com/xpla-staking',
          'des': 'PoS Node allows you to stake your XPLA and recieve rewards directly from the XPLA blockchain network. Learn how to stake XPLA, the current staking interest, validator fees, rewards calculations and more.',
          'image': 'https://www.posnode.com/static/images/social/social_staking_xpla.jpg',
          'title': 'XPLA Staking'
        },
        'injective-staking': {
          'url': 'https://www.posnode.com/injective-staking',
          'des': 'PoS Node allows you to stake your INJ and recieve rewards directly from the Injective blockchain network. Learn how to stake INJ, the current staking interest, validator fees, rewards calculations and more.',
          'image': 'https://www.posnode.com/static/images/social/social_staking_injective.jpg',
          'title': 'Injective Staking'
        },
        'persistence-staking': {
          'url': 'https://www.posnode.com/persistence-staking',
          'des': 'PoS Node allows you to stake your XPRT and recieve rewards directly from the Persistence blockchain network. Learn how to stake XPRT, the current staking interest, validator fees, rewards calculations and more.',
          'image': 'https://www.posnode.com/static/images/social/social_staking_persistence.jpg',
          'title': 'Persistence Staking'
        },
        'provenance-staking': {
          'url': 'https://www.posnode.com/provenance-staking',
          'des': 'PoS Node allows you to stake your HASH and recieve rewards directly from the Provenance blockchain network. Learn how to stake HASH, the current staking interest, validator fees, rewards calculations and more.',
          'image': 'https://www.posnode.com/static/images/social/social_staking_provenance.jpg',
          'title': 'Provenance Staking'
        },
        'stargaze-staking': {
          'url': 'https://www.posnode.com/stargaze-staking',
          'des': 'PoS Node allows you to stake your STARS and recieve rewards directly from the Stargaze blockchain network. Learn how to stake STARS, the current staking interest, validator fees, rewards calculations and more.',
          'image': 'https://www.posnode.com/static/images/social/social_staking_stargaze.jpg',
          'title': 'Stargaze Staking'
        },
        'comdex-staking': {
          'url': 'https://www.posnode.com/comdex-staking',
          'des': 'PoS Node allows you to stake your CMDX and recieve rewards directly from the Comdex  blockchain network. Learn how to stake CMDX, the current staking interest, validator fees, rewards calculations and more.',
          'image': 'https://www.posnode.com/static/images/social/social_staking_comdex.jpg',
          'title': 'Comdex Staking'
        },
        'evmos-staking': {
          'url': 'https://www.posnode.com/evmos-staking',
          'des': 'PoS Node allows you to stake your EVMOS and recieve rewards directly from the Evmos blockchain network. Learn how to stake EVMOS, the current staking interest, validator fees, rewards calculations and more.',
          'image': 'https://www.posnode.com/static/images/social/social_staking_evmos.jpg',
          'title': 'Evmos Staking'
        },
        'cudos-staking': {
          'url': 'https://www.posnode.com/cudos-staking',
          'des': 'PoS Node allows you to stake your CUDOS and recieve rewards directly from the Cudos blockchain network. Learn how to stake CUDOS, the current staking interest, validator fees, rewards calculations and more.',
          'image': 'https://www.posnode.com/static/images/social/social_staking_cudos.jpg',
          'title': 'Cudos Staking'
        },
        'osmosis-staking': {
          'url': 'https://www.posnode.com/osmosis-staking',
          'des': 'PoS Node allows you to stake your OSMO and recieve rewards directly from the Osmosis blockchain network. Learn how to stake OSMO, the current staking interest, validator fees, rewards calculations and more.',
          'image': 'https://www.posnode.com/static/images/social/social_staking_osmosis.jpg',
          'title': 'Osmosis Staking'
        },
        'cronos-staking': {
          'url': 'https://www.posnode.com/cronos-staking',
          'des': 'PoS Node allows you to stake your CRO and recieve rewards directly from the Cronos blockchain network. Learn how to stake CRO, the current staking interest, validator fees, rewards calculations and more.',
          'image': 'https://www.posnode.com/static/images/social/social_staking_cronos.jpg',
          'title': 'Cronos Staking'
        }
      }
    }
  },
  watch: {
    $route () {
      let uri = this.$route.path
      if (this.$route.path === '/tron-staking') {
        $("meta[property='og:image']").attr('content', this.meta_data['tron-staking']['image'])
        $("meta[name='twitter:image:src']").attr('content', this.meta_data['tron-staking']['image'])
        $("meta[property='og:title']").attr('content', this.meta_data['tron-staking']['title'])
        $("meta[name='twitter:title']").attr('content', this.meta_data['tron-staking']['title'])
        $("meta[property='og:description']").attr('content', this.meta_data['tron-staking']['des'])
        $("meta[name='twitter:description']").attr('content', this.meta_data['tron-staking']['des'])
        $("meta[property='og:url']").attr('content', this.meta_data['tron-staking']['url'])
        $("meta[name='twitter:url']").attr('content', this.meta_data['tron-staking']['url'])
      } else if (uri === '/solana-staking-rewards-01') {
        $("meta[property='og:image']").attr('content', this.meta_data['solana-staking-rewards-01']['image'])
        $("meta[name='twitter:image:src']").attr('content', this.meta_data['solana-staking-rewards-01']['image'])
        $("meta[property='og:title']").attr('content', this.meta_data['solana-staking-rewards-01']['title'])
        $("meta[name='twitter:title']").attr('content', this.meta_data['solana-staking-rewards-01']['title'])
        $("meta[property='og:description']").attr('content', this.meta_data['solana-staking-rewards-01']['des'])
        $("meta[name='twitter:description']").attr('content', this.meta_data['solana-staking-rewards-01']['des'])
        $("meta[property='og:url']").attr('content', this.meta_data['solana-staking-rewards-01']['url'])
        $("meta[name='twitter:url']").attr('content', this.meta_data['solana-staking-rewards-01']['url'])
      } else if (uri === '/cardano-rewards-01') {
        $("meta[property='og:image']").attr('content', this.meta_data['cardano-rewards-01']['image'])
        $("meta[name='twitter:image:src']").attr('content', this.meta_data['cardano-rewards-01']['image'])
        $("meta[property='og:title']").attr('content', this.meta_data['cardano-rewards-01']['title'])
        $("meta[name='twitter:title']").attr('content', this.meta_data['cardano-rewards-01']['title'])
        $("meta[property='og:description']").attr('content', this.meta_data['cardano-rewards-01']['des'])
        $("meta[name='twitter:description']").attr('content', this.meta_data['cardano-rewards-01']['des'])
        $("meta[property='og:url']").attr('content', this.meta_data['cardano-rewards-01']['url'])
        $("meta[name='twitter:url']").attr('content', this.meta_data['cardano-rewards-01']['url'])
      } else if (uri === '/cardano-summer-staking-rewards') {
        $("meta[property='og:image']").attr('content', this.meta_data['cardano-summer-staking-rewards']['image'])
        $("meta[name='twitter:image:src']").attr('content', this.meta_data['cardano-summer-staking-rewards']['image'])
        $("meta[property='og:title']").attr('content', this.meta_data['cardano-summer-staking-rewards']['title'])
        $("meta[name='twitter:title']").attr('content', this.meta_data['cardano-summer-staking-rewards']['title'])
        $("meta[property='og:description']").attr('content', this.meta_data['cardano-summer-staking-rewards']['des'])
        $("meta[name='twitter:description']").attr('content', this.meta_data['cardano-summer-staking-rewards']['des'])
        $("meta[property='og:url']").attr('content', this.meta_data['cardano-summer-staking-rewards']['url'])
        $("meta[name='twitter:url']").attr('content', this.meta_data['cardano-summer-staking-rewards']['url'])
      } else if (uri === '/cardano-staking') {
        $("meta[property='og:image']").attr('content', this.meta_data['cardano-staking']['image'])
        $("meta[name='twitter:image:src']").attr('content', this.meta_data['cardano-staking']['image'])
        $("meta[property='og:title']").attr('content', this.meta_data['cardano-staking']['title'])
        $("meta[name='twitter:title']").attr('content', this.meta_data['cardano-staking']['title'])
        $("meta[property='og:description']").attr('content', this.meta_data['cardano-staking']['des'])
        $("meta[name='twitter:description']").attr('content', this.meta_data['cardano-staking']['des'])
        $("meta[property='og:url']").attr('content', this.meta_data['cardano-staking']['url'])
        $("meta[name='twitter:url']").attr('content', this.meta_data['cardano-staking']['url'])
      } else if (uri === '/irisnet-staking') {
        $("meta[property='og:image']").attr('content', this.meta_data['irisnet-staking']['image'])
        $("meta[name='twitter:image:src']").attr('content', this.meta_data['irisnet-staking']['image'])
        $("meta[property='og:title']").attr('content', this.meta_data['irisnet-staking']['title'])
        $("meta[name='twitter:title']").attr('content', this.meta_data['irisnet-staking']['title'])
        $("meta[property='og:description']").attr('content', this.meta_data['irisnet-staking']['des'])
        $("meta[name='twitter:description']").attr('content', this.meta_data['irisnet-staking']['des'])
        $("meta[property='og:url']").attr('content', this.meta_data['irisnet-staking']['url'])
        $("meta[name='twitter:url']").attr('content', this.meta_data['irisnet-staking']['url'])
      } else if (uri === '/certiK-staking') {
        $("meta[property='og:image']").attr('content', this.meta_data['certiK-staking']['image'])
        $("meta[name='twitter:image:src']").attr('content', this.meta_data['certiK-staking']['image'])
        $("meta[property='og:title']").attr('content', this.meta_data['certiK-staking']['title'])
        $("meta[name='twitter:title']").attr('content', this.meta_data['certiK-staking']['title'])
        $("meta[property='og:description']").attr('content', this.meta_data['certiK-staking']['des'])
        $("meta[name='twitter:description']").attr('content', this.meta_data['certiK-staking']['des'])
        $("meta[property='og:url']").attr('content', this.meta_data['certiK-staking']['url'])
        $("meta[name='twitter:url']").attr('content', this.meta_data['certiK-staking']['url'])
      } else if (uri === '/gravity-bridge-staking') {
        $("meta[property='og:image']").attr('content', this.meta_data['gravity-bridge-staking']['image'])
        $("meta[name='twitter:image:src']").attr('content', this.meta_data['gravity-bridge-staking']['image'])
        $("meta[property='og:title']").attr('content', this.meta_data['gravity-bridge-staking']['title'])
        $("meta[name='twitter:title']").attr('content', this.meta_data['gravity-bridge-staking']['title'])
        $("meta[property='og:description']").attr('content', this.meta_data['gravity-bridge-staking']['des'])
        $("meta[name='twitter:description']").attr('content', this.meta_data['gravity-bridge-staking']['des'])
        $("meta[property='og:url']").attr('content', this.meta_data['gravity-bridge-staking']['url'])
        $("meta[name='twitter:url']").attr('content', this.meta_data['gravity-bridge-staking']['url'])
      } else if (uri === '/oasis-network-staking') {
        $("meta[property='og:image']").attr('content', this.meta_data['oasis-network-staking']['image'])
        $("meta[name='twitter:image:src']").attr('content', this.meta_data['oasis-network-staking']['image'])
        $("meta[property='og:title']").attr('content', this.meta_data['oasis-network-staking']['title'])
        $("meta[name='twitter:title']").attr('content', this.meta_data['oasis-network-staking']['title'])
        $("meta[property='og:description']").attr('content', this.meta_data['oasis-network-staking']['des'])
        $("meta[name='twitter:description']").attr('content', this.meta_data['oasis-network-staking']['des'])
        $("meta[property='og:url']").attr('content', this.meta_data['oasis-network-staking']['url'])
        $("meta[name='twitter:url']").attr('content', this.meta_data['oasis-network-staking']['url'])
      } else if (uri === '/tezos-staking') {
        $("meta[property='og:image']").attr('content', this.meta_data['tezos-staking']['image'])
        $("meta[name='twitter:image:src']").attr('content', this.meta_data['tezos-staking']['image'])
        $("meta[property='og:title']").attr('content', this.meta_data['tezos-staking']['title'])
        $("meta[name='twitter:title']").attr('content', this.meta_data['tezos-staking']['title'])
        $("meta[property='og:description']").attr('content', this.meta_data['tezos-staking']['des'])
        $("meta[name='twitter:description']").attr('content', this.meta_data['tezos-staking']['des'])
        $("meta[property='og:url']").attr('content', this.meta_data['tezos-staking']['url'])
        $("meta[name='twitter:url']").attr('content', this.meta_data['tezos-staking']['url'])
      } else if (uri === '/near-staking') {
        $("meta[property='og:image']").attr('content', this.meta_data['near-staking']['image'])
        $("meta[name='twitter:image:src']").attr('content', this.meta_data['near-staking']['image'])
        $("meta[property='og:title']").attr('content', this.meta_data['near-staking']['title'])
        $("meta[name='twitter:title']").attr('content', this.meta_data['near-staking']['title'])
        $("meta[property='og:description']").attr('content', this.meta_data['near-staking']['des'])
        $("meta[name='twitter:description']").attr('content', this.meta_data['near-staking']['des'])
        $("meta[property='og:url']").attr('content', this.meta_data['near-staking']['url'])
        $("meta[name='twitter:url']").attr('content', this.meta_data['near-staking']['url'])
      } else if (uri === '/terra-classic-staking') {
        $("meta[property='og:image']").attr('content', this.meta_data['terra-classic-staking']['image'])
        $("meta[name='twitter:image:src']").attr('content', this.meta_data['terra-classic-staking']['image'])
        $("meta[property='og:title']").attr('content', this.meta_data['terra-classic-staking']['title'])
        $("meta[name='twitter:title']").attr('content', this.meta_data['terra-classic-staking']['title'])
        $("meta[property='og:description']").attr('content', this.meta_data['terra-classic-staking']['des'])
        $("meta[name='twitter:description']").attr('content', this.meta_data['terra-classic-staking']['des'])
        $("meta[property='og:url']").attr('content', this.meta_data['terra-classic-staking']['url'])
        $("meta[name='twitter:url']").attr('content', this.meta_data['terra-classic-staking']['url'])
      } else if (uri === '/solana-staking') {
        $("meta[property='og:image']").attr('content', this.meta_data['solana-staking']['image'])
        $("meta[name='twitter:image:src']").attr('content', this.meta_data['solana-staking']['image'])
        $("meta[property='og:title']").attr('content', this.meta_data['solana-staking']['title'])
        $("meta[name='twitter:title']").attr('content', this.meta_data['solana-staking']['title'])
        $("meta[property='og:description']").attr('content', this.meta_data['solana-staking']['des'])
        $("meta[name='twitter:description']").attr('content', this.meta_data['solana-staking']['des'])
        $("meta[property='og:url']").attr('content', this.meta_data['solana-staking']['url'])
        $("meta[name='twitter:url']").attr('content', this.meta_data['solana-staking']['url'])
      } else if (uri === '/Band-Protocol-staking') {
        $("meta[property='og:image']").attr('content', this.meta_data['Band-Protocol-staking']['image'])
        $("meta[name='twitter:image:src']").attr('content', this.meta_data['Band-Protocol-staking']['image'])
        $("meta[property='og:title']").attr('content', this.meta_data['Band-Protocol-staking']['title'])
        $("meta[name='twitter:title']").attr('content', this.meta_data['Band-Protocol-staking']['title'])
        $("meta[property='og:description']").attr('content', this.meta_data['Band-Protocol-staking']['des'])
        $("meta[name='twitter:description']").attr('content', this.meta_data['Band-Protocol-staking']['des'])
        $("meta[property='og:url']").attr('content', this.meta_data['Band-Protocol-staking']['url'])
        $("meta[name='twitter:url']").attr('content', this.meta_data['Band-Protocol-staking']['url'])
      } else if (uri === '/kava-staking') {
        $("meta[property='og:image']").attr('content', this.meta_data['kava-staking']['image'])
        $("meta[name='twitter:image:src']").attr('content', this.meta_data['kava-staking']['image'])
        $("meta[property='og:title']").attr('content', this.meta_data['kava-staking']['title'])
        $("meta[name='twitter:title']").attr('content', this.meta_data['kava-staking']['title'])
        $("meta[property='og:description']").attr('content', this.meta_data['kava-staking']['des'])
        $("meta[name='twitter:description']").attr('content', this.meta_data['kava-staking']['des'])
        $("meta[property='og:url']").attr('content', this.meta_data['kava-staking']['url'])
        $("meta[name='twitter:url']").attr('content', this.meta_data['kava-staking']['url'])
      } else if (uri === '/akash-network-staking') {
        $("meta[property='og:image']").attr('content', this.meta_data['akash-network-staking']['image'])
        $("meta[name='twitter:image:src']").attr('content', this.meta_data['akash-network-staking']['image'])
        $("meta[property='og:title']").attr('content', this.meta_data['akash-network-staking']['title'])
        $("meta[name='twitter:title']").attr('content', this.meta_data['akash-network-staking']['title'])
        $("meta[property='og:description']").attr('content', this.meta_data['akash-network-staking']['des'])
        $("meta[name='twitter:description']").attr('content', this.meta_data['akash-network-staking']['des'])
        $("meta[property='og:url']").attr('content', this.meta_data['akash-network-staking']['url'])
        $("meta[name='twitter:url']").attr('content', this.meta_data['akash-network-staking']['url'])
      } else if (uri === '/umee-staking') {
        $("meta[property='og:image']").attr('content', this.meta_data['umee-staking']['image'])
        $("meta[name='twitter:image:src']").attr('content', this.meta_data['umee-staking']['image'])
        $("meta[property='og:title']").attr('content', this.meta_data['umee-staking']['title'])
        $("meta[name='twitter:title']").attr('content', this.meta_data['umee-staking']['title'])
        $("meta[property='og:description']").attr('content', this.meta_data['umee-staking']['des'])
        $("meta[name='twitter:description']").attr('content', this.meta_data['umee-staking']['des'])
        $("meta[property='og:url']").attr('content', this.meta_data['umee-staking']['url'])
        $("meta[name='twitter:url']").attr('content', this.meta_data['umee-staking']['url'])
      } else if (uri === '/sentinel-staking') {
        $("meta[property='og:image']").attr('content', this.meta_data['sentinel-staking']['image'])
        $("meta[name='twitter:image:src']").attr('content', this.meta_data['sentinel-staking']['image'])
        $("meta[property='og:title']").attr('content', this.meta_data['sentinel-staking']['title'])
        $("meta[name='twitter:title']").attr('content', this.meta_data['sentinel-staking']['title'])
        $("meta[property='og:description']").attr('content', this.meta_data['sentinel-staking']['des'])
        $("meta[name='twitter:description']").attr('content', this.meta_data['sentinel-staking']['des'])
        $("meta[property='og:url']").attr('content', this.meta_data['sentinel-staking']['url'])
        $("meta[name='twitter:url']").attr('content', this.meta_data['sentinel-staking']['url'])
      } else if (uri === '/sommelier-staking') {
        $("meta[property='og:image']").attr('content', this.meta_data['sommelier-staking']['image'])
        $("meta[name='twitter:image:src']").attr('content', this.meta_data['sommelier-staking']['image'])
        $("meta[property='og:title']").attr('content', this.meta_data['sommelier-staking']['title'])
        $("meta[name='twitter:title']").attr('content', this.meta_data['sommelier-staking']['title'])
        $("meta[property='og:description']").attr('content', this.meta_data['sommelier-staking']['des'])
        $("meta[name='twitter:description']").attr('content', this.meta_data['sommelier-staking']['des'])
        $("meta[property='og:url']").attr('content', this.meta_data['sommelier-staking']['url'])
        $("meta[name='twitter:url']").attr('content', this.meta_data['sommelier-staking']['url'])
      } else if (uri === '/fetch-ai-staking') {
        $("meta[property='og:image']").attr('content', this.meta_data['fetch-ai-staking']['image'])
        $("meta[name='twitter:image:src']").attr('content', this.meta_data['fetch-ai-staking']['image'])
        $("meta[property='og:title']").attr('content', this.meta_data['fetch-ai-staking']['title'])
        $("meta[name='twitter:title']").attr('content', this.meta_data['fetch-ai-staking']['title'])
        $("meta[property='og:description']").attr('content', this.meta_data['fetch-ai-staking']['des'])
        $("meta[name='twitter:description']").attr('content', this.meta_data['fetch-ai-staking']['des'])
        $("meta[property='og:url']").attr('content', this.meta_data['fetch-ai-staking']['url'])
        $("meta[name='twitter:url']").attr('content', this.meta_data['fetch-ai-staking']['url'])
      } else if (uri === '/juno-staking') {
        $("meta[property='og:image']").attr('content', this.meta_data['juno-staking']['image'])
        $("meta[name='twitter:image:src']").attr('content', this.meta_data['juno-staking']['image'])
        $("meta[property='og:title']").attr('content', this.meta_data['juno-staking']['title'])
        $("meta[name='twitter:title']").attr('content', this.meta_data['juno-staking']['title'])
        $("meta[property='og:description']").attr('content', this.meta_data['juno-staking']['des'])
        $("meta[name='twitter:description']").attr('content', this.meta_data['juno-staking']['des'])
        $("meta[property='og:url']").attr('content', this.meta_data['juno-staking']['url'])
        $("meta[name='twitter:url']").attr('content', this.meta_data['juno-staking']['url'])
      } else if (uri === '/regen-network-staking') {
        $("meta[property='og:image']").attr('content', this.meta_data['regen-network-staking']['image'])
        $("meta[name='twitter:image:src']").attr('content', this.meta_data['regen-network-staking']['image'])
        $("meta[property='og:title']").attr('content', this.meta_data['regen-network-staking']['title'])
        $("meta[name='twitter:title']").attr('content', this.meta_data['regen-network-staking']['title'])
        $("meta[property='og:description']").attr('content', this.meta_data['regen-network-staking']['des'])
        $("meta[name='twitter:description']").attr('content', this.meta_data['regen-network-staking']['des'])
        $("meta[property='og:url']").attr('content', this.meta_data['regen-network-staking']['url'])
        $("meta[name='twitter:url']").attr('content', this.meta_data['regen-network-staking']['url'])
      } else if (uri === '/quicksilver-zone-staking') {
        $("meta[property='og:image']").attr('content', this.meta_data['quicksilver-zone-staking']['image'])
        $("meta[name='twitter:image:src']").attr('content', this.meta_data['quicksilver-zone-staking']['image'])
        $("meta[property='og:title']").attr('content', this.meta_data['quicksilver-zone-staking']['title'])
        $("meta[name='twitter:title']").attr('content', this.meta_data['quicksilver-zone-staking']['title'])
        $("meta[property='og:description']").attr('content', this.meta_data['quicksilver-zone-staking']['des'])
        $("meta[name='twitter:description']").attr('content', this.meta_data['quicksilver-zone-staking']['des'])
        $("meta[property='og:url']").attr('content', this.meta_data['quicksilver-zone-staking']['url'])
        $("meta[name='twitter:url']").attr('content', this.meta_data['quicksilver-zone-staking']['url'])
      } else if (uri === '/xpla-staking') {
        $("meta[property='og:image']").attr('content', this.meta_data['xpla-staking']['image'])
        $("meta[name='twitter:image:src']").attr('content', this.meta_data['xpla-staking']['image'])
        $("meta[property='og:title']").attr('content', this.meta_data['xpla-staking']['title'])
        $("meta[name='twitter:title']").attr('content', this.meta_data['xpla-staking']['title'])
        $("meta[property='og:description']").attr('content', this.meta_data['xpla-staking']['des'])
        $("meta[name='twitter:description']").attr('content', this.meta_data['xpla-staking']['des'])
        $("meta[property='og:url']").attr('content', this.meta_data['xpla-staking']['url'])
        $("meta[name='twitter:url']").attr('content', this.meta_data['xpla-staking']['url'])
      } else if (uri === '/injective-staking') {
        $("meta[property='og:image']").attr('content', this.meta_data['injective-staking']['image'])
        $("meta[name='twitter:image:src']").attr('content', this.meta_data['injective-staking']['image'])
        $("meta[property='og:title']").attr('content', this.meta_data['injective-staking']['title'])
        $("meta[name='twitter:title']").attr('content', this.meta_data['injective-staking']['title'])
        $("meta[property='og:description']").attr('content', this.meta_data['injective-staking']['des'])
        $("meta[name='twitter:description']").attr('content', this.meta_data['injective-staking']['des'])
        $("meta[property='og:url']").attr('content', this.meta_data['injective-staking']['url'])
        $("meta[name='twitter:url']").attr('content', this.meta_data['injective-staking']['url'])
      } else if (uri === '/persistence-staking') {
        $("meta[property='og:image']").attr('content', this.meta_data['persistence-staking']['image'])
        $("meta[name='twitter:image:src']").attr('content', this.meta_data['persistence-staking']['image'])
        $("meta[property='og:title']").attr('content', this.meta_data['persistence-staking']['title'])
        $("meta[name='twitter:title']").attr('content', this.meta_data['persistence-staking']['title'])
        $("meta[property='og:description']").attr('content', this.meta_data['persistence-staking']['des'])
        $("meta[name='twitter:description']").attr('content', this.meta_data['persistence-staking']['des'])
        $("meta[property='og:url']").attr('content', this.meta_data['persistence-staking']['url'])
        $("meta[name='twitter:url']").attr('content', this.meta_data['persistence-staking']['url'])
      } else if (uri === '/provenance-staking') {
        $("meta[property='og:image']").attr('content', this.meta_data['provenance-staking']['image'])
        $("meta[name='twitter:image:src']").attr('content', this.meta_data['provenance-staking']['image'])
        $("meta[property='og:title']").attr('content', this.meta_data['provenance-staking']['title'])
        $("meta[name='twitter:title']").attr('content', this.meta_data['provenance-staking']['title'])
        $("meta[property='og:description']").attr('content', this.meta_data['provenance-staking']['des'])
        $("meta[name='twitter:description']").attr('content', this.meta_data['provenance-staking']['des'])
        $("meta[property='og:url']").attr('content', this.meta_data['provenance-staking']['url'])
        $("meta[name='twitter:url']").attr('content', this.meta_data['provenance-staking']['url'])
      } else if (uri === '/stargaze-staking') {
        $("meta[property='og:image']").attr('content', this.meta_data['stargaze-staking']['image'])
        $("meta[name='twitter:image:src']").attr('content', this.meta_data['stargaze-staking']['image'])
        $("meta[property='og:title']").attr('content', this.meta_data['stargaze-staking']['title'])
        $("meta[name='twitter:title']").attr('content', this.meta_data['stargaze-staking']['title'])
        $("meta[property='og:description']").attr('content', this.meta_data['stargaze-staking']['des'])
        $("meta[name='twitter:description']").attr('content', this.meta_data['stargaze-staking']['des'])
        $("meta[property='og:url']").attr('content', this.meta_data['stargaze-staking']['url'])
        $("meta[name='twitter:url']").attr('content', this.meta_data['stargaze-staking']['url'])
      } else if (uri === '/comdex-staking') {
        $("meta[property='og:image']").attr('content', this.meta_data['comdex-staking']['image'])
        $("meta[name='twitter:image:src']").attr('content', this.meta_data['comdex-staking']['image'])
        $("meta[property='og:title']").attr('content', this.meta_data['comdex-staking']['title'])
        $("meta[name='twitter:title']").attr('content', this.meta_data['comdex-staking']['title'])
        $("meta[property='og:description']").attr('content', this.meta_data['comdex-staking']['des'])
        $("meta[name='twitter:description']").attr('content', this.meta_data['comdex-staking']['des'])
        $("meta[property='og:url']").attr('content', this.meta_data['comdex-staking']['url'])
        $("meta[name='twitter:url']").attr('content', this.meta_data['comdex-staking']['url'])
      } else if (uri === '/evmos-staking') {
        $("meta[property='og:image']").attr('content', this.meta_data['evmos-staking']['image'])
        $("meta[name='twitter:image:src']").attr('content', this.meta_data['evmos-staking']['image'])
        $("meta[property='og:title']").attr('content', this.meta_data['evmos-staking']['title'])
        $("meta[name='twitter:title']").attr('content', this.meta_data['evmos-staking']['title'])
        $("meta[property='og:description']").attr('content', this.meta_data['evmos-staking']['des'])
        $("meta[name='twitter:description']").attr('content', this.meta_data['evmos-staking']['des'])
        $("meta[property='og:url']").attr('content', this.meta_data['evmos-staking']['url'])
        $("meta[name='twitter:url']").attr('content', this.meta_data['evmos-staking']['url'])
      } else if (uri === '/cudos-staking') {
        $("meta[property='og:image']").attr('content', this.meta_data['cudos-staking']['image'])
        $("meta[name='twitter:image:src']").attr('content', this.meta_data['cudos-staking']['image'])
        $("meta[property='og:title']").attr('content', this.meta_data['cudos-staking']['title'])
        $("meta[name='twitter:title']").attr('content', this.meta_data['cudos-staking']['title'])
        $("meta[property='og:description']").attr('content', this.meta_data['cudos-staking']['des'])
        $("meta[name='twitter:description']").attr('content', this.meta_data['cudos-staking']['des'])
        $("meta[property='og:url']").attr('content', this.meta_data['cudos-staking']['url'])
        $("meta[name='twitter:url']").attr('content', this.meta_data['cudos-staking']['url'])
      } else if (uri === '/osmosis-staking') {
        $("meta[property='og:image']").attr('content', this.meta_data['osmosis-staking']['image'])
        $("meta[name='twitter:image:src']").attr('content', this.meta_data['osmosis-staking']['image'])
        $("meta[property='og:title']").attr('content', this.meta_data['osmosis-staking']['title'])
        $("meta[name='twitter:title']").attr('content', this.meta_data['osmosis-staking']['title'])
        $("meta[property='og:description']").attr('content', this.meta_data['osmosis-staking']['des'])
        $("meta[name='twitter:description']").attr('content', this.meta_data['osmosis-staking']['des'])
        $("meta[property='og:url']").attr('content', this.meta_data['osmosis-staking']['url'])
        $("meta[name='twitter:url']").attr('content', this.meta_data['osmosis-staking']['url'])
      } else if (uri === '/cronos-staking') {
        $("meta[property='og:image']").attr('content', this.meta_data['cronos-staking']['image'])
        $("meta[name='twitter:image:src']").attr('content', this.meta_data['cronos-staking']['image'])
        $("meta[property='og:title']").attr('content', this.meta_data['cronos-staking']['title'])
        $("meta[name='twitter:title']").attr('content', this.meta_data['cronos-staking']['title'])
        $("meta[property='og:description']").attr('content', this.meta_data['cronos-staking']['des'])
        $("meta[name='twitter:description']").attr('content', this.meta_data['cronos-staking']['des'])
        $("meta[property='og:url']").attr('content', this.meta_data['cronos-staking']['url'])
        $("meta[name='twitter:url']").attr('content', this.meta_data['cronos-staking']['url'])
      }
    }
  },
  created () {
    this.get('https://sa.coinpayu.com/api/crontab/stakingList').then((res) => {
      this.$store.commit('changeCoinMsg', res.data.data)
      this.$store.commit('changeIndexCoinMsg', res.data.filter_data)
    }).catch((err) => {
      console.log(err)
    })
  }
}
</script>

<style>
*,p,h1,h2,h3,h4{
  margin: 0;
  padding: 0;
}
ul,li{
  list-style: none;
}
html,body{
  background-color: #F5F7F7;
}
@font-face {
  font-family: 'FRAHV';
  src: url('../static/fonts/FRAHV.ttf') format('opentype');
}
@font-face {
  font-family: 'DIN';
  src: url('../static/fonts/DIN.ttf') format('opentype');
}
@font-face {
  font-family: 'PingFangSC-Medium';
  src: url('../static/fonts/PingFangSC-Medium.otf') format('opentype');
}
@font-face {
  font-family: 'PingFangSC-Heavy';
  src: url('../static/fonts/PingFangSC-Heavy.otf') format('opentype');
}
@font-face {
  font-family: 'DFPYaSongW9-GB';
  src: url('../static/fonts/DFPYaSongW9-GB.ttf') format('opentype');
}
@font-face {
  font-family: 'DFPYaSongW9';
  src: url('../static/fonts/DFPGBYS9.ttf?v=1.1.') format("truetype");
  font-weight: 400;
  font-style: normal;
}
@font-face{
    font-family: 'PingFang';
    src: url('../static/fonts/PingFang_Bold.ttf?v=1.1.') format("truetype");
    font-weight: normal;
    font-style: normal;
}
</style>



// WEBPACK FOOTER //
// src/App.vue